import React from "react";
import { Tooltip, tooltipClasses, TooltipProps } from "@mui/material";
import { styled } from "@mui/material/styles";

const CustomWidthTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    fontSize: "1.075rem",
    maxWidth: 500,
  },
});

function CustomTooltip(props: TooltipProps) {
  const { children } = props;
  return <CustomWidthTooltip {...props}>{children}</CustomWidthTooltip>;
}

export default CustomTooltip;
